<section class="header-img-wrapper">

    <ng-container *ngFor="let items of PhotoItem">
        <ng-container *ngIf="items.categorycontent">

            <div class="container-full-img">

                <picture>
                    <source media="(min-width: 992px)" srcset="{{items.imageLg}}">
                    <source media="(min-width: 480px)" srcset="{{items.imageMd}}">
                    <source media="(min-width: 0px)" srcset="{{items.imageSm}}">
                    <img class="img-responsive" src="{{items.imageLg}}"
                         alt="Alexander Koenig">
                </picture>
            </div>

            <article class="container-full" *ngIf="items.headerContent">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 col-sm-8 col-md-6">
                            <div class="container-full-content">

                                <h2 class="headline-special">Fotografie<span>- {{items.title}}</span>
                                </h2>

                                <p>{{items.headerContent}}</p>

                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </ng-container>
    </ng-container>
</section>
<section id="wrapper" class="container content-wrapper detail">
    <nav class="sub-sub-menu">

        <div id="newsbreadcrumb">
            <ul id="breadcrumb">
                <li><a (click)="updateData($event)" routerLink="/photography"
                       routerLinkActive="active">Fotografie</a></li>
                <li><a (click)="updateData($event)" routerLink="/photography/architecture"
                       routerLinkActive="active">Architektur</a></li>
                <li><a (click)="updateData($event)" routerLink="/photography/landscape"
                       routerLinkActive="active">Landschaft</a></li>
                <li><a (click)="updateData($event)" routerLink="/photography/sailing"
                       routerLinkActive="active">Segeln</a></li>
                <li><a (click)="updateData($event)"
                       routerLink="/photography/weltcup" routerLinkActive="active">Sport</a></li>
                <li><a (click)="updateData($event)" routerLink="/photography/local"
                       routerLinkActive="active">Lokales</a></li>
                <li>
                    <a (click)="updateData($event)" routerLink="/photography/event"
                       routerLinkActive="active">Event</a>
                </li>
                <li>
                    <a (click)="updateData($event)" routerLink="/photography/muenchner_sommernachtstraum"
                       routerLinkActive="active">Münchner Sommernachtstraum</a>
                </li>
            </ul>
        </div>

    </nav>
    <ng-container *ngFor="let items of PhotoItem">
        <article class="row" *ngIf="items.categorycontent">
            <div class="col-xs-12">
                <h1 class="headline">Fotografie - {{items.title}}</h1>
            </div>
        </article>
    </ng-container>
    <div class="gallery">
        <!--<ng-container *ngFor="let items of PhotoItem">
            <ng-container *ngIf="items.image">
                <div class='image {{items.IClass}}'>
                    <img (click)="openDialog(items)" class="lazy-image" src="{{items.image}}"
                         alt="{{items.alt}}"/></div>

                <pre>{{items | json}}</pre>
            </ng-container>
        </ng-container>-->

        <ng-container *ngFor="let items of PhotoItem">

                <div *ngIf="items.image" class='image {{items.IClass}}'>
                    <img (click)="openDialog(items)" class="lazy-image" src="{{items.image}}"
                         alt="{{items.alt}}"/>
                </div>
                <!--[defaultImage]="items.image"
                [lazyLoad]="items.image"-->

        </ng-container>

    </div>
    <div  *ngIf="PhotoItem.length <= 10" class="more-pictures">weitere Fotos folgen in Kürze...</div>
</section>

